import { Link, useLocation } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { generateBreadcrumbItems } from './breadcrumbUtils';
import './Breadcrumb.css';

export function Breadcrumb() {
  const location = useLocation();
  const items = generateBreadcrumbItems(location.pathname);

  return (
    <nav className="breadcrumb" aria-label="Breadcrumb">
      <ol className="breadcrumb-list">
        {items.map((item, index) => (
          <li key={item.path} className="breadcrumb-item">
            {index > 0 && <ChevronRight size={14} className="breadcrumb-separator" />}
            {item.isLast ? (
              <span className="breadcrumb-current" aria-current="page">{item.label}</span>
            ) : (
              <Link to={item.path} className="breadcrumb-link">{item.label}</Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
